import axios from "axios";

// const API_URL = "http://localhost:4000/api/users/";
const API_URL = "https://diucapstone1.onrender.com/api/users/";

// Register user
const register = async (user) => {
  // const config = { headers: { "Content-Type": "multipart/form-data" } };

  const response = await axios.post(API_URL + "register", user);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }

  return response.data;
};

// Login user
const login = async (userData) => {
  const response = await axios.post(API_URL + "login", userData);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }

  return response.data;
};

// Logout user
const logout = () => {
  localStorage.removeItem("user");
};

const forgotPassword = async (email) => {
  ///
  const response = await axios.post(API_URL + "forgot-password", { email });
  return response.data;
};

const resetPassword = async (data) => {
  const response = await axios.post(API_URL + "reset-password", data);
  return response.data;
};

const authService = {
  register,
  logout,
  login,
  forgotPassword,
  resetPassword,
};

export default authService;
